export enum EventsModalType {
  GET_MORE_ENVELOPES = 'get-more-envelopes',
  REVIEW_DOCUMENTS = 'review-documents',
}
